import React from 'react';
import { DynamicModuleLoader } from 'redux-dynamic-modules';
import { getDiscordModule } from './module';
const ModuleLoader = ()=>{
    return /*#__PURE__*/ React.createElement(DynamicModuleLoader, {
        modules: [
            getDiscordModule()
        ]
    });
};
ModuleLoader.displayName = 'ModuleLoader';
export default ModuleLoader;

//# sourceMappingURL=ModuleLoader.js.map